// CommonJS: Gatsby imports it fine; functions requires it for the parity check
// (dioscuro/functions/lib/__tests__/lessonVideoParity.test.js).
const ACTIONS = ["idle", "talk", "point", "walk"];

function _str(v, max, label) {
  if (typeof v !== "string" || !v.trim()) {
    const err = new Error(`${label} required`);
    err.code = "invalid-argument";
    throw err;
  }
  if (v.length > max) {
    const err = new Error(`${label} too long`);
    err.code = "invalid-argument";
    throw err;
  }
  return v.trim();
}

function validateScript(input) {
  const s = input || {};
  const voice = _str(s.voice, 60, "voice");
  if (!Array.isArray(s.beats) || s.beats.length < 1 || s.beats.length > 40) {
    const err = new Error("beats must be 1–40");
    err.code = "invalid-argument";
    throw err;
  }
  const beats = s.beats.map((b) => {
    const beat = b || {};
    const narration = _str(beat.narration, 600, "narration");
    if (!ACTIONS.includes(beat.action)) {
      const err = new Error(`invalid action: ${beat.action}`);
      err.code = "invalid-argument";
      throw err;
    }
    const caption = (typeof beat.caption === "string" && beat.caption.trim()) ? beat.caption.trim().slice(0, 2000) : narration;
    const out = { narration, action: beat.action, caption };
    if (typeof beat.code === "string" && beat.code.trim()) out.code = beat.code.slice(0, 2000);
    return out;
  });
  return { voice, beats };
}

function advanceTimeline(state, event, beatCount) {
  const n = beatCount || 1;
  const clamp = (i) => Math.max(0, Math.min(n - 1, i));
  const { index, playing } = state;
  switch (event) {
    case "play": return { index, playing: true };
    case "pause": return { index, playing: false };
    case "next": return { index: clamp(index + 1), playing };
    case "prev": return { index: clamp(index - 1), playing };
    case "ended": return index + 1 < n ? { index: index + 1, playing: true } : { index, playing: false };
    default: return state;
  }
}

function validateLessonBody(input) {
  return _str(input, 20000, "body");
}

module.exports = { validateScript, advanceTimeline, validateLessonBody, ACTIONS };
